import _ from 'lodash';

import connect from 'components/lib/connect';
import ExternalFormForm from './external_form_form';

export default connect(mapStateToProps)(ExternalFormForm);

function mapStateToProps({ getProvider, isFeatureEnabled }, props) {
  let customer = getProvider('profile').get();
  let customerId = _.get(customer, 'id');

  let externalActionForm = getProvider('externalActionForm').get();
  let isWaitingOnAction = getProvider('performExternalAction').isLoading();
  let errors = getProvider('externalActionForm').getErrors();
  let compositionErrors = _.filter(errors, err => !err.attr);

  return {
    ...props,
    externalActionForm,
    isWaitingOnAction,
    customerId,
    errors,
    compositionErrors,
  };
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/composition/external_form_container.jsx